import Container from "../components/Container";
import MainCard from "../components/MainCard";
import PageContainer from "../components/PageContainer";
import ImageWithTooltip from "./ImageWithTooltip";

const DetailSection = ({
  bgImg = "/images/hero-image.jpeg",
  pageTitle = "",
  headerTitle = "",
  image = "https://via.placeholder.com/400x400",
  alt = "",
  title = "",
  content = "",
  isHeaderTitleBottom = false,
}) => {
  return (
    <PageContainer bgImg={bgImg} title={pageTitle}>
      <Container isAlignTop>
        <MainCard>
          <div
            className={`flex ${
              isHeaderTitleBottom ? "flex-col-reverse" : "flex-col"
            } `}
          >
            {headerTitle && (
              <div className="header-content">
                <h2 className="header-content__title">
                  {headerTitle ?? "หัวข้อ"}
                </h2>
              </div>
            )}
            <ImageWithTooltip
              src={image}
              className="object-contain rounded-lg w-full"
              alt={alt}
            />
          </div>
          <div
            className="dangerous-html-content"
            dangerouslySetInnerHTML={{
              __html: title ?? <></>,
            }}
          />
          <div
            className="dangerous-html-content"
            dangerouslySetInnerHTML={{
              __html: content ?? <></>,
            }}
          />
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default DetailSection;
